import { Images, Video } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import MediaGallery from "@/components/admin/MediaGallery";
import VideoGallery from "@/components/admin/VideoGallery";

export default function MediaLibrary() {
  return (
    <Tabs defaultValue="images" data-testid="media-library">
      <TabsList className="bg-[#F1F5F9] mb-5">
        <TabsTrigger value="images" data-testid="media-tab-images" className="data-[state=active]:bg-[#2563EB] data-[state=active]:text-white"><Images size={14} className="mr-1.5" /> Gambar</TabsTrigger>
        <TabsTrigger value="videos" data-testid="media-tab-videos" className="data-[state=active]:bg-[#2563EB] data-[state=active]:text-white"><Video size={14} className="mr-1.5" /> Video</TabsTrigger>
      </TabsList>
      <TabsContent value="images"><MediaGallery /></TabsContent>
      <TabsContent value="videos"><VideoGallery /></TabsContent>
    </Tabs>
  );
}
